// External modules
import acHTTPClient from 'services/ACHTTPClient';

// Internal modules
import * as constants from '../constants';
import config from '../../../config/config';
import { onAuthError } from '../auth';

let limit = config.limit.default;
// TODO: Use SSM
const experienceAPIURL = `${config.experienceAPIURL}/api/v1`;

const getSparksError = (error) => {
  return {
    type: constants.GET_SPARKS_ERROR,
    error,
  };
};

const getSparksSuccess = (sparks) => {
  return {
    type: constants.GET_SPARKS_SUCCESS,
    sparks: sparks,
  };
};

const getSparkError = (error) => {
  return {
    type: constants.GET_SPARK_ERROR,
    error,
  };
};

const getSparkSuccess = (spark) => {
  return {
    type: constants.GET_SPARK_SUCCESS,
    spark: spark,
  };
};

const createNewSparkSuccess = (spark) => {
  return {
    type: constants.GET_SPARK_SUCCESS,
    spark: spark,
  };
};

const getSparks = (filterParams) => {
  let apiURL = `${experienceAPIURL}/sparks?limit=${limit}`;
  if (filterParams) {
    apiURL += '&' + filterParams.slice(1); // Remove extra & from the filter string
  }
  return (dispatch) => {
    const config = { url: apiURL, method: 'GET' };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(getSparksError(response.statusText));
        }
        dispatch(getSparksSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getSparksError(error));
      });
  };
};

const getSparksFromGrid = (filterParams) => {
  let apiURL = `${experienceAPIURL}/sparks-grid?limit=${limit}`;
  if (filterParams) {
    apiURL += '&query=' + filterParams;
  }
  return (dispatch) => {
    const config = { url: apiURL, method: 'GET' };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(getSparksError(response.statusText));
        }
        dispatch(getSparksSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getSparksError(error));
      });
  };
};

const getSpark = (id) => {
  let apiURL = `${experienceAPIURL}/sparks/${id}`;
  return (dispatch) => {
    const config = { url: apiURL, method: 'GET' };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(getSparkError(response.statusText));
        }
        dispatch(getSparkSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getSparkError(error));
      });
  };
};

const postSparkError = (error) => {
  return {
    type: constants.POST_SPARK_ERROR,
    error,
  };
};

const postSparkSuccess = (spark) => {
  return {
    type: constants.POST_SPARK_SUCCESS,
    spark: spark,
  };
};

const postSpark = (newSpark, isCopy) => {
  let apiURL = `${experienceAPIURL}/sparks`;
  if (isCopy) {
    const config = { url: apiURL, method: 'POST', data: newSpark };
    return new Promise((resolve, reject) => {
      acHTTPClient
        .request(config)
        .then(response => {
          return resolve(response.data);
        })
        .catch(error => {
          return reject(error);
        });
    });
  } else {
    return (dispatch) => {
      const config = { url: apiURL, method: 'POST', data: newSpark };
      acHTTPClient
        .request(config)
        .then((response) => {
          if (!response.data || response.data.error) {
            dispatch(postSparkError(response.statusText));
          }
          dispatch(postSparkSuccess(response.data));
        })
        .catch((error) => {
          onAuthError(error);
          dispatch(postSparkError(error));
        });
    };
  }
};

const patchSparkError = (error) => {
  return {
    type: constants.PATCH_SPARK_ERROR,
    error,
  };
};

const patchSparkSuccess = (spark) => {
  return {
    type: constants.PATCH_SPARK_SUCCESS,
    spark: spark,
  };
};

const patchSpark = (spark) => {
  let apiURL = `${experienceAPIURL}/sparks/${spark.id}`;
  return (dispatch) => {
    const config = { url: apiURL, method: 'PATCH', data: spark };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(patchSparkError(response.statusText));
        }
        dispatch(patchSparkSuccess(response.data));
      })
      .catch((error) => {
        onAuthError(error);
        dispatch(patchSparkError(error));
      });
  };
};

const patchSparkNote = (sparkId, note) => {
  let apiURL = `${experienceAPIURL}/sparks/${sparkId}/notes`;
  return (dispatch) => {
    const config = { url: apiURL, method: 'PATCH', data: note };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(patchSparkError(response.statusText));
        }
        dispatch(patchSparkSuccess(response.data));
      })
      .catch((error) => {
        onAuthError(error);
        dispatch(patchSparkError(error));
      });
  };
};

const putAdditionalFunsError = (error) => {
  return {
    type: constants.PUT_ADDITIONAL_FUNS_ERROR,
    error,
  };
};

const putAdditionalFunsSuccess = (additionalFuns) => {
  return {
    type: constants.PUT_ADDITIONAL_FUNS_SUCCESS,
    additionalFuns: additionalFuns,
  };
};

const putAdditionalFuns = (sparkId, newAdditionalFun) => {
  let apiURL = `${experienceAPIURL}/sparks/${sparkId}/additional-funs`;
  return (dispatch) => {
    const config = { url: apiURL, method: 'PUT', data: newAdditionalFun };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(putAdditionalFunsError(response.statusText));
        }
        dispatch(putAdditionalFunsSuccess(response.data));
      })
      .catch((error) => {
        onAuthError(error);
        dispatch(putAdditionalFunsError(error));
      });
  };
};

const createNewSpark = () => {
  const spark = { id: '-1', status: 'active' };
  return (dispatch) => {
    dispatch(createNewSparkSuccess({ data: spark }));
  };
};

export {
  createNewSpark,
  getSparks,
  getSpark,
  postSpark,
  patchSpark,
  putAdditionalFuns,
  patchSparkNote,
  getSparksFromGrid,

};
